import { PathParams } from './types'
import { stringify } from 'qs'
import { EmptyObject } from '../types/UtilityTypes'

export function urlWithParams<Params extends PathParams>(params: Params) {
    return (url: string): string => {
        return Object.entries(params).reduce((acc, [key, value]) => {
            return acc.replace(new RegExp(':' + key), '' + value)
        }, url)
    }
}

export const urlWithQuery = <Q extends EmptyObject>(query: Q): (url: string) => string => {
    const queryString = stringify(query, {
        skipNulls: true,
        filter: (prefix, value) => {
            if (value === undefined) {
                return
            }
            return value
        },
    })
    return (url: string) => url + (queryString ? ('?' + queryString) : '')
}